<template>
  <ExpenseFeeModalSectionOperational
    :active="active"
    :form="form"
    :options="options"
    :hide-sale-customer-fields="hideSaleCustomerFields"
    :text="text.sections.sharedOperational"
    :common-text="text.sections.common"
  />
</template>

<script>
import ExpenseFeeModalSectionOperational from '@/components/expensesFees/modal/ExpenseFeeModalSections/ExpenseFeeModalSectionOperational.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('fees');

export default {
  name: 'FeeModalSectionOperational',
  components: {
    ExpenseFeeModalSectionOperational,
  },
  data() {
    return {
      text,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    hideSaleCustomerFields: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
